import React, { FunctionComponent } from 'react';

import Coin from '@bitcoin-portal/verse-web-components/dist/Coin';
import CoinPair from '@bitcoin-portal/verse-web-components/dist/CoinPair';

import { useTrackedState } from '@context/store';

import { findExternalIcon } from '@helpers/index';

import { SingleCoinWrapper } from './styled';

interface Props {
  farm: IFarmPair;
}

export const CoinDisplay: FunctionComponent<Props> = ({ farm }) => {
  const { provider: exchangeProvider } = useTrackedState();

  const { pair } = farm;
  return (
    <>
      {farm.singleSided ? (
        <SingleCoinWrapper>
          <Coin
            alt={pair?.token0?.symbol}
            isErc
            altSrc={findExternalIcon(
              pair?.token0?.id,
              pair?.token0?.symbol,
              exchangeProvider,
            )}
            ticker={pair?.token0?.symbol}
            size="27px"
          />
        </SingleCoinWrapper>
      ) : (
        <CoinPair
          coinA={{
            alt: pair?.token0?.symbol,
            altSrc: findExternalIcon(
              pair?.token0?.id,
              pair?.token0?.symbol,
              exchangeProvider,
            ),
            ticker: pair?.token0?.symbol,
            size: '27px',
          }}
          coinB={{
            alt: pair?.token1?.symbol,
            altSrc: findExternalIcon(
              pair?.token1?.id,
              pair?.token1?.symbol,
              exchangeProvider,
            ),
            ticker: pair?.token1?.symbol,
            size: '27px',
          }}
        />
      )}
    </>
  );
};

export default CoinDisplay;
